import {
  FETCH_EXPANSION_INFO,
  FETCH_EXPANSION_INFO_SUCCESS,
  ADD_EXPANSION,
  ADD_EXPANSION_FETCH,
  ADD_EXPANSION_FETCH_ERROR,
  FETCH_EXPANSION_INFO_ERROR,
  FETCH_EXPANSION_FETCH,
  FETCH_EXPANSION_FETCH_SUCCESS,
  FETCH_EXPANSION_FETCH_ERROR
} from "../actions/types";
import {
  FREE_EXPANSION,
  PREMIUM1_EXPANSION,
  PREMIUM2_EXPANSION
} from "../../constants/expansions";

interface ExpansionInfo {
  count: number;
  free_expansion: boolean;
  premium1_expansion: boolean;
  premium2_expansion: boolean;
  premium3_expansion: boolean;
}

export interface ExpansionsActionInterface {
  type: string;
  info?: ExpansionInfo;
  expansions?: {
    [key: string]: { count: number; images: string[] };
  };
}
export interface ManyExpansionInterface {
  [key: string]: { count: number; images: string[] };
}

export interface ExpansionInterface {
  errorFetching: string;
  loading: boolean;
  adding_expansion: boolean;
  info?: ExpansionInfo;
  expansions?: ManyExpansionInterface;
}

const INITIAL_STATE: ExpansionInterface = {
  errorFetching: "",
  loading: false,
  adding_expansion: false,
  info: undefined,
  expansions: {
    [FREE_EXPANSION]: { count: 0, images: [] },
    [PREMIUM1_EXPANSION]: { count: 0, images: [] },
    [PREMIUM2_EXPANSION]: { count: 0, images: [] }
  }
};

const expansion = (
  state: ExpansionInterface = INITIAL_STATE,
  action: ExpansionsActionInterface
): ExpansionInterface => {
  switch (action.type) {
    case FETCH_EXPANSION_INFO:
      return {
        ...state,
        loading: true
      };
    case FETCH_EXPANSION_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        info: action.info
      };
    case FETCH_EXPANSION_INFO_ERROR:
      return {
        ...state,
        loading: false,
        errorFetching: "Error on fetching expansions"
      };
    case FETCH_EXPANSION_FETCH:
      return {
        ...state,
        loading: true
      };
    case FETCH_EXPANSION_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        expansions: action.expansions
      };
    case FETCH_EXPANSION_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        errorFetching: "Error on fetching expansions images"
      };
    case ADD_EXPANSION:
      return {
        ...state,
        adding_expansion: true
      };
    case ADD_EXPANSION_FETCH:
      return {
        ...state,
        adding_expansion: false
      };
    case ADD_EXPANSION_FETCH_ERROR:
      return {
        ...state,
        adding_expansion: false,
        errorFetching: "Error on adding expansion"
      };
    default:
      return state;
  }
};

export default expansion;
